module.exports = __webpack_public_path__ + "static/media/moduleSet_i1o1.cca64dcb.jpg";